import React from 'react';
import { PriceString } from '../../functional/PriceString';
import * as S from './styled';
export const ProfitString = ({ value }) => {
    const symbol = value > 0 ? '+' : '';
    return (React.createElement(S.Text, { "$value": value },
        symbol,
        React.createElement(PriceString, { value: value })));
};
